module.exports = __webpack_public_path__ + "img/transitilogo.a9ebb5c6.svg";